import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  alert,
  DateRangePicker,
  profile,
  total,
  toFixed,
  format_date,
  GET,
  POST,
  loading,
  params,
  MonthPicker,
  Select,
  Navbar,
  XLSX,
  saveAs,
} from "../../components/CustomComponent.js";
export default class Profits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_date: format_date(new Date(), "yyyy-mm", "en"),
      filter_broker: "",
      filter_currency: "THB",

      data: [],
      loaded: false,
      count: 10,
      data_broker: [],
      export_date: "",
      modal_excel: false,
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(0)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker;
    let [result_broker] = await Promise.all([
      GET("v1/admin/brokers/options", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        gateway: e.gateway_deposits,
        // ถ้า API ยังไม่ส่ง is_active มา ถือว่าเปิดใช้งาน
        is_active: e.is_active !== false,
      }));
    }
    this.setState({ data_broker });
  };
  Get = async (page) => {
    let data, count;

    const { filter_date, filter_currency } = this.state;
    loading(true);
    let _date = new Date(filter_date);
    let _date_start = format_date(
      new Date(_date.getFullYear(), _date.getMonth(), 1),
      "yyyy-MM-dd",
      "en"
    );
    let _date_end = format_date(
      new Date(_date.getFullYear(), _date.getMonth() + 1, 0),
      "yyyy-MM-dd",
      "en"
    );

    let [result] = await Promise.all([
        GET("profits/monthly", {
            page_size: 100000,
            page: 0,
            data_search: "",
            start_date: filter_date ? format_date(_date_start, "yyyy-mm-dd", "en") : "",
            end_date: filter_date ? format_date(_date_end, "yyyy-mm-dd", "en") : "",
            currency: filter_currency,
        }),
      ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    // เก็บข้อมูลทุก broker ไว้ แล้วค่อยกรอง broker ตอน render (ไม่ต้องยิง API ใหม่)
    this.setState({
      data: data || [],
      loaded: true,
      count,
    });
    loading(false);
  };
  // แถวที่แสดงจริง = ข้อมูลของเดือน + broker ที่เปิดใช้งานแต่ไม่มีข้อมูล (ค่า 0)
  // กรองด้วย broker ที่เลือก (ถ้ามี) และเรียงยอดรวมฝาก+ถอนมากไปน้อย ตัวที่เป็น 0 ไปท้ายเรียงตามชื่อ
  VisibleRows = () => {
    const { data, data_broker, filter_broker, filter_date } = this.state;
    const num = (v) => Number(v) || 0;
    const rows = [...(data || [])];
    const seen = new Set(rows.map((e) => e.broker?.uid).filter(Boolean));
    const d = filter_date ? new Date(filter_date) : null;
    const year = d && !isNaN(d) ? d.getFullYear() : "";
    const month = d && !isNaN(d) ? d.getMonth() + 1 : "";
    (data_broker || [])
      .filter((b) => b.is_active && !seen.has(b.value))
      .forEach((b) =>
        rows.push({
          year,
          month,
          broker: { uid: b.value, name_en: b.label },
          deposit_amount: 0,
          deposit_fee: 0,
          deposit_commission: 0,
          deposit_revenue: 0,
          withdrawal_amount: 0,
          withdrawal_fee: 0,
          withdrawal_revenue: 0,
          _empty: true,
        })
      );
    const volume = (e) => num(e.deposit_amount) + num(e.withdrawal_amount);
    return rows
      .filter((e) => !filter_broker || (e.broker?.uid || "").includes(filter_broker))
      .sort(
        (a, b) =>
          volume(b) - volume(a) ||
          (a.broker?.name_en || "").localeCompare(b.broker?.name_en || "")
      );
  };
  ExportCSV = () => {
    const { filter_date, filter_currency } = this.state;
    const rows = this.VisibleRows();
    const columns = [
      "Year", "Month", "Broker",
      "Deposit Amount", "Deposit Fee", "Deposit Commission", "Deposit Revenue",
      "Withdrawal Amount", "Withdrawal Fee", "Withdrawal Revenue",
    ];
    const body = rows.map((item) => [
      item.year,
      item.month,
      item.broker?.name_en || "",
      item.deposit_amount || 0,
      item.deposit_fee || 0,
      item.deposit_commission || 0,
      item.deposit_revenue || 0,
      item.withdrawal_amount || 0,
      item.withdrawal_fee || 0,
      item.withdrawal_revenue || 0,
    ]);
    body.push([
      "", "", "TOTAL",
      total(rows, "deposit_amount"),
      total(rows, "deposit_fee"),
      total(rows, "deposit_commission"),
      total(rows, "deposit_revenue"),
      total(rows, "withdrawal_amount"),
      total(rows, "withdrawal_fee"),
      total(rows, "withdrawal_revenue"),
    ]);
    const escape = (v) => {
      const s = v === null || v === undefined ? "" : String(v);
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const csv = [columns, ...body].map((r) => r.map(escape).join(",")).join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `monthly-report-${filter_date}-${filter_currency}.csv`);
  };
  // broker_uid / broker_name ส่งมาจากปุ่มในแถว ถ้าไม่ส่งจะใช้ broker ที่เลือกใน filter
  RecalculateMonthly = async (broker_uid, broker_name) => {
    const { filter_date, filter_broker, filter_currency, data_broker } = this.state;
    const targetBroker = broker_uid || filter_broker;
    const selectedBrokerName =
      broker_name ||
      data_broker?.find((item) => item.value === targetBroker)?.label ||
      targetBroker;

    if (!targetBroker || !filter_date) {
      alert(
        "",
        "warning",
        "Warning",
        "Select Broker and Month before using Recalc"
      );
      return;
    }

    if (
      await alert(
        "",
        "info",
        "Confirm Recalc",
        `${selectedBrokerName} - ${format_date(filter_date, "mm/yyyy", "en")} - ${filter_currency}`,
        "confirm",
        "cancel"
      )
    ) {
      const date = new Date(filter_date);
      const start_date = format_date(
        new Date(date.getFullYear(), date.getMonth(), 1),
        "yyyy-mm-dd",
        "en"
      );
      const end_date = format_date(
        new Date(date.getFullYear(), date.getMonth() + 1, 0),
        "yyyy-mm-dd",
        "en"
      );

      loading(true);
      const result = await POST("v1/admin/profits/monthly/recalc", {
          broker_uid: targetBroker,
          currency: filter_currency,
          start_date,
          end_date,
      });

      if (result?.status) {
        loading(false);
        await alert("", "success", "Success", "Recalculate monthly completed");
        await this.Get(1);
      } else {
        loading(false);
        await alert("", "error", "Error", result?.message || "Recalculate monthly failed");
      }
    }
  };
  render() {
    const { filter_date, filter_broker, filter_currency, loaded, data_broker } =
      this.state;
    const rows = this.VisibleRows();
    const isSuper = profile.user_type === "super_user";

    const cell = (v) => (v ? toFixed(v) : "0.00");
    const num = (v) => Number(v) || 0;
    const revenueClass = (v) =>
      num(v) < 0 ? "ar-neg" : num(v) === 0 ? "ar-zero" : "";
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const monthShort = (m) =>
      Number(m) >= 1 && Number(m) <= 12
        ? monthNames[Number(m) - 1].slice(0, 3)
        : m;
    const selectedDate = filter_date ? new Date(filter_date) : null;
    const heroMonth =
      selectedDate && !isNaN(selectedDate)
        ? monthNames[selectedDate.getMonth()].slice(0, 3).toUpperCase()
        : "—";
    const heroYear =
      selectedDate && !isNaN(selectedDate) ? selectedDate.getFullYear() : "";
    const currency = global.currency?.find(
      (c) => c.currency_code === filter_currency
    );
    const currencySymbol =
      filter_currency === "THB" ? "฿" : filter_currency === "LAK" ? "₭" : "";
    const selectedBrokerLabel = data_broker?.find(
      (b) => b.value === filter_broker
    )?.label;

    const sum = {
      deposit_amount: total(rows, "deposit_amount"),
      deposit_fee: total(rows, "deposit_fee"),
      deposit_commission: total(rows, "deposit_commission"),
      deposit_revenue: total(rows, "deposit_revenue"),
      withdrawal_amount: total(rows, "withdrawal_amount"),
      withdrawal_fee: total(rows, "withdrawal_fee"),
      withdrawal_revenue: total(rows, "withdrawal_revenue"),
    };
    const kpis = [
      {
        label: "Deposit Revenue",
        value: toFixed(sum.deposit_revenue, 2),
        sub: `Fee ${toFixed(sum.deposit_fee, 2)} · Commission ${toFixed(sum.deposit_commission, 2)}`,
        accent: "#14b8a6",
        icon: "",
        negative: sum.deposit_revenue < 0,
      },
      {
        label: "Withdrawal Revenue",
        value: toFixed(sum.withdrawal_revenue, 2),
        sub: `Fee ${toFixed(sum.withdrawal_fee, 2)}`,
        accent: "#f59e0b",
        icon: "",
        negative: sum.withdrawal_revenue < 0,
      },
      {
        label: "Total Volume",
        value: toFixed(sum.deposit_amount + sum.withdrawal_amount, 2),
        sub: `Deposit ${toFixed(sum.deposit_amount, 2)} · Withdrawal ${toFixed(sum.withdrawal_amount, 2)}`,
        accent: "#6366f1",
        icon: "",
      },
      {
        label: "Total Revenue",
        value: toFixed(sum.deposit_revenue + sum.withdrawal_revenue, 2),
        sub: `${rows.filter((e) => !e._empty).length}/${rows.length} broker${rows.length === 1 ? "" : "s"} with data · Deposit + Withdrawal`,
        accent: "#d4af37",
        icon: "",
        negative: sum.deposit_revenue + sum.withdrawal_revenue < 0,
        highlight: true,
      },
    ];

    return (
      <div className="w-100 min-vh-100 premium-report">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* ===== Hero ===== */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Monthly Report</div>
                <div className="ar-title">Monthly Reports</div>
                <div className="ar-subtitle">
                  Monthly transaction and revenue analysis
                </div>
              </div>
              <div className="ar-hero-actions">
                  {isSuper && (
                    <button
                      className="ar-btn-ghost monthlies.update"
                      onClick={() => this.RecalculateMonthly()}
                    >
                      <span className="icon me-2">{""}</span>Recalc
                    </button>
                  )}
                  <button
                    className="ar-btn-ghost monthlies.read"
                    onClick={this.ExportCSV}
                  >
                    <span className="icon me-2">{""}</span>Export CSV
                  </button>
                <div className="text-end ms-2">
                <div className="ar-year">
                  {heroMonth}
                  <span className="ar-year-small"> {heroYear}</span>
                </div>
                <div className="ar-year-caption">
                  {selectedBrokerLabel && (
                    <span className="ar-caption-chip ms-2">{selectedBrokerLabel}</span>
                  )}
                </div>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-4">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Month</span>
                  <MonthPicker
                    className="form-control"
                    placeholder="Month..."
                    clearable={false}
                    value={filter_date}
                    onChange={(e) => {
                      this.setState({ filter_date: e }, () => this.Get(1));
                    }}
                  />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Broker</span>
                  <Select
                    className="form-control"
                    placeholder="All brokers"
                    options={data_broker}
                    value={filter_broker}
                    onChange={(e) => {
                      this.setState({ filter_broker: e });
                    }}
                  />
                </div>
              <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_date: format_date(new Date(), "yyyy-mm", "en"),
                        filter_broker: "",
                        filter_currency: "THB",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  <span className="icon me-2">{""}</span>Reset
                </button>
              </div>
              </div>
              <div className="ar-filter-foot">
                <div className="d-flex align-items-center gap-2">
                  {global.currency?.map((item) => (
                    <button
                      key={item.currency_code}
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code }, () =>
                          this.Get(1)
                        );
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* ===== KPI summary (รวมจากแถวที่แสดง) ===== */}
          <div className="row g-3 mb-4">
            {kpis.map((k) => (
              <div className="col-12 col-sm-6 col-xl-3" key={k.label}>
                <div
                  className={`ar-kpi ${k.highlight ? "ar-kpi-highlight" : ""}`}
                  style={{ "--ar-accent": k.accent }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="ar-kpi-label">{k.label}</div>
                    <div className="ar-kpi-icon">
                      <span className="icon">{k.icon}</span>
                    </div>
                  </div>
                  <div className={`ar-kpi-value ${k.negative ? "ar-neg" : ""}`}>
                    <span className="ar-kpi-currency">{currencySymbol}</span>
                    {k.value}
                  </div>
                  <div className="ar-kpi-sub">{k.sub}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ===== Table ===== */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">Broker Breakdown</div>
                <div className="ar-table-caption">
                  {heroMonth} {heroYear} · {filter_currency} ·{" "}
                  {selectedBrokerLabel ? selectedBrokerLabel : "All active brokers"} ·{" "}
                  {rows.length} broker{rows.length === 1 ? "" : "s"} · sorted by volume
                </div>
              </div>
              <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                <span><i className="ar-legend-dot ar-legend-dep"></i>Deposits</span>
                <span><i className="ar-legend-dot ar-legend-wd"></i>Withdrawals</span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table">
                <thead>
                  <tr>
                    <td className="text-center align-middle" rowSpan={2}>Year</td>
                    <td className="text-center align-middle" rowSpan={2}>Month</td>
                    <td className="align-middle ar-sticky" rowSpan={2}>Broker</td>
                    <td className="text-center ar-group ar-group-dep ar-group-start" colSpan={4}>
                      <span className="icon me-2">{""}</span>Deposits
                    </td>
                    <td className="text-center ar-group ar-group-wd ar-group-start" colSpan={isSuper ? 4 : 3}>
                      <span className="icon me-2">{""}</span>Withdrawals
                    </td>
                  </tr>
                  <tr>
                    <td className="text-end ar-group-start">Amount</td>
                    <td className="text-end">Fee</td>
                    <td className="text-end">Commission</td>
                    <td className="text-end ar-head-profit">Revenue</td>
                    <td className="text-end ar-group-start">Amount</td>
                    <td className="text-end">Fee</td>
                    <td className="text-end ar-head-profit">Revenue</td>
                    {isSuper && <td className="text-center td-actions">Actions</td>}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => (
                    <tr key={`array-${index}`} className={item._empty ? "ar-row-empty" : ""}>
                      <td data-label="Year" className="text-center ar-muted">
                        {item.year}
                      </td>
                      <td data-label="Month" className="text-center">
                        <div className="ar-month-badge justify-content-center">
                          <span>{monthShort(item.month)}</span>
                        </div>
                      </td>
                      <td data-label="Broker" className="ar-sticky ar-broker">
                        {item.broker?.name_en || ""}
                        {item._empty && <span className="ar-chip-empty ms-2">no data</span>}
                      </td>
                      <td data-label="Deposit Amount" className="text-end ar-group-start">
                        {cell(item.deposit_amount)}
                      </td>
                      <td data-label="Deposit Fee" className="text-end ar-muted">
                        {cell(item.deposit_fee)}
                      </td>
                      <td data-label="Deposit Commission" className="text-end ar-muted">
                        {cell(item.deposit_commission)}
                      </td>
                      <td
                        data-label="Deposit Revenue"
                        className={`text-end ar-dep-profit ${revenueClass(item.deposit_revenue)}`}
                      >
                        {cell(item.deposit_revenue)}
                      </td>
                      <td data-label="Withdraw Amount" className="text-end ar-group-start">
                        {cell(item.withdrawal_amount)}
                      </td>
                      <td data-label="Withdraw Fee" className="text-end ar-muted">
                        {cell(item.withdrawal_fee)}
                      </td>
                      <td
                        data-label="Withdraw Revenue"
                        className={`text-end ar-wd-profit ${revenueClass(item.withdrawal_revenue)}`}
                      >
                        {cell(item.withdrawal_revenue)}
                      </td>
                      {isSuper && (
                        <td data-label="Actions" className="text-center td-actions pu-scope">
                          <Dropdown align="end">
                            <Dropdown.Toggle className="pu-action-toggle" id={`monthlies-actions-${index}`}>Action</Dropdown.Toggle>
                            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                              <Dropdown.Item
                                className="pu-action-item monthlies.update"
                                onClick={() =>
                                  this.RecalculateMonthly(
                                    item.broker?.uid,
                                    item.broker?.name_en
                                  )
                                }
                              >
                                <span className="icon">{""}</span>Recalculate
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      )}
                    </tr>
                  ))}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={isSuper ? 11 : 10} className="text-center py-5">
                        <div className="ar-empty">
                          <span className="icon d-block mb-2">{""}</span>
                          No data for {heroMonth} {heroYear} · {filter_currency}
                          {selectedBrokerLabel ? ` · ${selectedBrokerLabel}` : ""}
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.length > 0 && (
                    <tr className="ar-total">
                      <td></td>
                      <td></td>
                      <td className="ar-sticky">
                        <div className="ar-month-badge">
                          <span className="ar-month-badge-total">Σ</span>
                          TOTAL
                        </div>
                      </td>
                      <td data-label="Deposit Amount" className="text-end ar-group-start">
                        {toFixed(sum.deposit_amount, 2)}
                      </td>
                      <td data-label="Deposit Fee" className="text-end">
                        {toFixed(sum.deposit_fee, 2)}
                      </td>
                      <td data-label="Deposit Commission" className="text-end">
                        {toFixed(sum.deposit_commission, 2)}
                      </td>
                      <td
                        data-label="Deposit Revenue"
                        className={`text-end ${revenueClass(sum.deposit_revenue)}`}
                      >
                        {toFixed(sum.deposit_revenue, 2)}
                      </td>
                      <td data-label="Withdraw Amount" className="text-end ar-group-start">
                        {toFixed(sum.withdrawal_amount, 2)}
                      </td>
                      <td data-label="Withdraw Fee" className="text-end">
                        {toFixed(sum.withdrawal_fee, 2)}
                      </td>
                      <td
                        data-label="Withdraw Revenue"
                        className={`text-end ${revenueClass(sum.withdrawal_revenue)}`}
                      >
                        {toFixed(sum.withdrawal_revenue, 2)}
                      </td>
                      {isSuper && <td className="td-actions"></td>}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
